import { isInvalidDate } from './type-check'

export const formatDate = (d: Date) => {
  if(isInvalidDate(d)) return '----.--.--'

  const year = d.getFullYear().toString()
  const month = (d.getMonth() + 1).toString().padStart(2, '0')
  const date = d.getDate().toString().padStart(2, '0')
  return `${year}.${month}.${date}`
}